import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Card } from '@components/bootstrap';
import AuthenticatedLayout from '../../layouts/AuthenticatedLayout';
import UserManagement from './components/UserManagement';
import RoleManagement from './components/RoleManagement';
import ProfileSettings from './components/ProfileSettings';
import AccountsManagement from './components/AccountsManagement';
import { canAccessSettingsSection, getPlanInfo } from '../../utils/permissions';
import './SettingsPage.scss';
const SettingsPage = () => {
    const { user, userRole, userPlan, hasRole, hasFeature, canAccess } = useAuth();
    const [activeTab, setActiveTab] = useState('profile');
    // Simple permission checks
    const canAccessProfile = canAccessSettingsSection(userRole, 'profile');
    const canAccessUsers = canAccessSettingsSection(userRole, 'users');
    const canAccessRoles = canAccessSettingsSection(userRole, 'roles');
    const canAccessAccounts = canAccessSettingsSection(userRole, 'accounts');
    // Overall settings access
    const canAccessSettings = canAccess('settings') || canAccessProfile;
    // Early return if user doesn't have access to settings
    if (!canAccessSettings) {
        return (_jsx(AuthenticatedLayout, { title: "\u2699\uFE0F Configura\u00E7\u00F5es", subtitle: "Gerencie suas configura\u00E7\u00F5es e prefer\u00EAncias", children: _jsx(Card, { isPageContent: true, children: _jsxs("div", { className: "text-center py-5", children: [_jsx("h3", { children: "\uD83D\uDD12 Acesso Negado" }), _jsx("p", { className: "text-muted", children: "Voc\u00EA n\u00E3o tem permiss\u00E3o para acessar as configura\u00E7\u00F5es." }), _jsx("p", { className: "text-muted", children: "Entre em contato com o administrador se precisar de acesso." })] }) }) }));
    }
    const tabs = [
        // Profile tab - always available if user can access settings
        ...(canAccessProfile ? [{
                id: 'profile',
                label: '👤 Meu Perfil',
                component: _jsx(ProfileSettings, {})
            }] : []),
        // Users management - for admins and superadmins
        ...(canAccessUsers ? [{
                id: 'users',
                label: '👥 Gestão de Usuários',
                component: _jsx(UserManagement, {})
            }] : []),
        // Roles management - for superadmins only
        ...(canAccessRoles ? [{
                id: 'roles',
                label: '🔐 Gestão de Perfis',
                component: _jsx(RoleManagement, {})
            }] : []),
        // Accounts management - for superadmins only
        ...(canAccessAccounts ? [{
                id: 'accounts',
                label: '🏢 Gestão de Contas',
                component: _jsx(AccountsManagement, {})
            }] : [])
    ];
    // Since tabs are already filtered by permissions, no need for additional filtering
    const availableTabs = tabs;
    const currentTab = availableTabs.find(tab => tab.id === activeTab) || availableTabs[0];
    // Get plan info for display
    const planInfo = getPlanInfo(userPlan?.type);
    return (_jsx(AuthenticatedLayout, { title: "Configura\u00E7\u00F5es", subtitle: "Gerencie suas configura\u00E7\u00F5es pessoais e do sistema", tabs: availableTabs, activeTab: activeTab, onTabChange: setActiveTab, children: _jsx("div", { className: "container-fluid", children: _jsx("div", { className: "row", children: _jsx("div", { className: "col-12", children: _jsx(Card, { isPageContent: true, enableHover: false, children: _jsxs("div", { className: "settings-content", children: [planInfo && (_jsxs("div", { className: "plan-info mb-4", children: [_jsxs("div", { className: "row", children: [_jsxs("div", { className: "col-md-8", children: [_jsxs("h6", { className: "text-muted mb-2", children: ["Plano Atual: ", _jsx("span", { className: "badge bg-primary", children: planInfo.name })] }), _jsxs("div", { className: "features-list", children: [_jsx("small", { className: "text-muted", children: _jsx("strong", { children: "Recursos dispon\u00EDveis:" }) }), _jsx("ul", { className: "list-unstyled mt-1", children: planInfo.features.map((feature, index) => (_jsx("li", { className: "text-muted", children: _jsxs("small", { children: ["\u2705 ", feature] }) }, index))) })] })] }), _jsx("div", { className: "col-md-4 text-end", children: userPlan?.type !== 'enterprise' && (_jsx("button", { className: "btn btn-outline-primary btn-sm", children: "\u2B06\uFE0F Fazer Upgrade" })) })] }), _jsx("hr", {})] })), _jsx("div", { className: "tab-content", children: _jsx("div", { className: "tab-pane fade show active", children: currentTab?.component }) })] }) }) }) }) }) }));
};
export default SettingsPage;
